"use client";

import { ComponentInfo } from "@builder.io/sdk-react";

export const CONSUMABLES_PRODUCT_DETAILS_CONTAINER_INPUTS = [
  {
    name: "hasBadge",
    type: "boolean",
  },
  {
    name: "overwriteBadgeText",
    type: "string",
  },
  {
    name: "hasDiscountBadge",
    type: "boolean",
  },
  {
    name: "hasStrikethroughPrice",
    type: "boolean",
  },
  {
    name: "hideCta",
    type: "boolean",
  },
  {
    name: "hidePrice",
    type: "boolean",
  },
] as const satisfies ComponentInfo["inputs"];

export const CONSUMABLES_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS = [
  {
    name: "sku",
    type: "string",
  },
  {
    name: "badgeText",
    type: "string",
  },
  {
    name: "description",
    type: "string",
  },
  {
    name: "shortDescription",
    type: "string",
  },
  {
    name: "knowMoreUrl",
    type: "string",
  },
  {
    name: "multiPackDescription",
    type: "string",
  },
  {
    name: "productCta",
    type: "object",
    subFields: [
      {
        name: "label",
        type: "string",
      },
      {
        name: "url",
        type: "string",
      },
    ],
  },
  {
    name: "productName",
    type: "string",
  },
  {
    name: "isCommerceDisabled",
    type: "boolean",
  },
  {
    name: "isMultiPackEnabled",
    type: "boolean",
  },
  {
    name: "multiPackName",
    type: "string",
  },
  {
    name: "multiPackProducts",
    type: "list",
  },
  {
    name: "customBuyCtaLabel",
    type: "string",
  },
  {
    name: "consumablesMatrixData",
    type: "object",
    subFields: [
      {
        name: "packagingFormats",
        type: "list",
      },
      {
        name: "items",
        type: "list",
      },
    ],
  },
  {
    name: "isSubscriptionsEnabled",
    type: "boolean",
  },
] as const satisfies ComponentInfo["inputs"];

export const ALL_CONSUMABLES_PRODUCT_DETAILS_CONTAINER_INPUTS = [
  ...CONSUMABLES_PRODUCT_DETAILS_CONTAINER_INPUTS,
  ...CONSUMABLES_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS,
] as const satisfies ComponentInfo["inputs"];

export type ConsumablesProductDetailsContainerProps = BuilderComponentProps<
  typeof ALL_CONSUMABLES_PRODUCT_DETAILS_CONTAINER_INPUTS
>;
